'use strict';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

import stringConverter from './converters/stringConverter';
var RADIX = 36;
/**
 * @memberof module:compressed-json
 * @function decompress
 * @param {Object} compressed
 * @param {Object} [options={}] - Optional settings
 */

function decompress(compressed) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$reservedKeys = options.reservedKeys,
      reservedKeys = _options$reservedKeys === void 0 ? [] : _options$reservedKeys,
      _options$reservedValu = options.reservedValues,
      reservedValues = _options$reservedValu === void 0 ? [] : _options$reservedValu;

  if (!compressed) {
    return null;
  }

  var _compressed$K = compressed.K,
      K = _compressed$K === void 0 ? [] : _compressed$K,
      _compressed$P = compressed.P,
      P = _compressed$P === void 0 ? [] : _compressed$P,
      values = compressed._;
  var keys = [].concat(_toConsumableArray(reservedKeys), _toConsumableArray(K));
  var pointers = [].concat(_toConsumableArray(reservedValues), _toConsumableArray(P));

  var stringValueFor = function stringValueFor(value) {
    if (stringConverter.isPointer(value)) {
      var index = parseInt(stringConverter.fromPointer(value), RADIX);
      return pointers[index];
    }

    return stringConverter.fromEscaped(value);
  };

  var convert = function convert(values) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$keyPath = _ref.keyPath,
        keyPath = _ref$keyPath === void 0 ? '' : _ref$keyPath;

    if (Array.isArray(values)) {
      return values.map(function (v, i) {
        return convert(v, {
          keyPath: [keyPath, i].join('/')
        });
      });
    }

    if (values === null) {
      return null;
    }

    switch (_typeof(values)) {
      case 'undefined':
        {
          return;
        }

      case 'function':
        return null;

      case 'object':
        {
          var decompressed = {};
          var shortKeys = Object.keys(values);

          for (var _i = 0, _shortKeys = shortKeys; _i < _shortKeys.length; _i++) {
            var shortKey = _shortKeys[_i];
            var value = values[shortKey];
            var key = keys[parseInt(shortKey, RADIX)];
            decompressed[key] = convert(value, {
              keyPath: [keyPath, shortKey].join('/')
            });
          }

          return decompressed;
        }

      case 'string':
        return stringValueFor(values, keyPath);

      default:
        return values;
    }
  };

  return convert(values);
}

decompress.fromString = function decompressFromString(compressedString) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return decompress(JSON.parse(compressedString), options);
};

export default decompress;